import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-[80px] mx-4 lg:mx-0" }
const _hoisted_2 = { class: "review-form-container" }
const _hoisted_3 = { class: "flex items-center justify-center mb-12" }

import { schema } from './schema';
import { initialValues } from './initialValues';
import { Form } from 'vee-validate';
import Logo from './components/Logo.vue';
import FormBody from './components/FormBody.vue';
import { ref } from 'vue';


export default {
  __name: 'ReviewForm',
  setup(__props) {

const status = ref('idle');
const onSubmit = (data) => {
    const formData = new FormData();

    formData.append('action', 'add_review');
    formData.append('message', data.message);
    formData.append('rating', data.rating);
    formData.append('email', data.email);

    fetch(jsData.ajaxUrl, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .then(() => {
            status.value = 'success';
        });
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Logo)
      ]),
      _createVNode(_unref(Form), {
        onKeydown: _cache[0] || (_cache[0] = _withKeys($event => ($event.preventDefault()), ["enter"])),
        "initial-values": _unref(initialValues),
        "validation-schema": _unref(schema),
        onSubmit: onSubmit
      }, {
        default: _withCtx(({ isSubmitting }) => [
          _createVNode(FormBody, {
            isSubmitting: isSubmitting,
            status: status.value
          }, null, 8, ["isSubmitting", "status"])
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema"])
    ])
  ]))
}
}

}